import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import LocaleFactory from "./LocaleFactory";

import { UserSettings } from "../Entities/Settings/User/UserSettings";
import { UserSettingsInterface } from "../Entities/Settings/User/UserSettingsInterface";

import LanguageContainer from "../../Translation/LanguageContainer";
import CurrencyContainer from "../../Currency/CurrencyContainer";

class UserSettingsFactory extends Factory implements FactoryInterface {

  public create(data: any): UserSettingsInterface {
    /*
    |  Some entities doesn't have settings. (e.g tenants or owners)
    |  So if the data is undefined, we have to load defaults.
    */

    if (typeof data === "undefined") {
      return new UserSettings({
        language: LanguageContainer.resolve("nl-NL"),
        currency: CurrencyContainer.pickFromId(1),
        locale: LocaleFactory.create({ iso: "nl-NL" }),
        beta: false,
        launchPanelState: true,
        entityPanelState: true,
        finishWelcomeCoach: false
      });
    }

    return new UserSettings({
      language: LanguageContainer.resolve(data.language),
      currency: CurrencyContainer.pickFromId(data.currency),
      locale: LocaleFactory.create({ iso: data.locale }),
      beta: data.beta,
      launchPanelState: data.launchPanelState,
      entityPanelState: data.entityPanelState,
      finishWelcomeCoach: data?.finishWelcomeCoach
    });
  }

  public reinitialize(data: any): UserSettingsInterface {
    return new UserSettings({
      ...data
    });
  }
}

export default new UserSettingsFactory();
